import { Refresh as RefreshIcon } from '@mui/icons-material';
import { Alert, Box, IconButton } from '@mui/material';

interface MessageListErrorProps {
  onRefresh: () => void;
}

export const MessageListError = ({ onRefresh }: MessageListErrorProps) => {
  return (
    <Box
      display='flex'
      flexDirection='row'
      justifyContent='center'
      alignItems='center'
      height='100%'
      width='100%'
      gap={2}
    >
      <Alert
        color='error'
        className='mex:items-center'
        icon={
          <IconButton onClick={onRefresh} color='error'>
            <RefreshIcon />
          </IconButton>
        }
      >
        Tải tin nhắn thất bại. Thử lại.
      </Alert>
    </Box>
  );
};
